import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class InvalidPaymentInformationsError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidPaymentInformationsError";
    }
}
export class InvalidSubscriptionPlanError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionPlanError";
    }
}
export class InvalidTrialPlanError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidTrialPlanError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    InvalidPaymentInformationsError,
    InvalidSubscriptionPlanError,
    InvalidTrialPlanError,
    ForbiddenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
